import React from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  Button,
} from "@mui/material";
import { InfoBlueIcon, CalenderIcon } from "../assets/icons";
import theme from "../theme";

interface BillingCycleModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  proRatedAmount: number;
  annualAmount: number;
}

const BillingCycleModal: React.FC<BillingCycleModalProps> = ({
  open,
  onClose,
  onConfirm,
  proRatedAmount,
  annualAmount,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
          p: "32px",
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <Typography variant="h5" fontWeight="500" mb={2}>
          Change to Annual billing
        </Typography>
        <Typography color={theme.palette.text.secondary} mb={3}>
          You're switching from monthly to annual billing for your Automated Gold Plan
        </Typography>
        
        <Box bgcolor="#F5F9FF" p={2} borderRadius={2} mb={3}>
          <Box display="flex" alignItems="center" gap={1}>
            <InfoBlueIcon />
            <Typography fontWeight="500">You'll save $99 per year</Typography>
          </Box>
          <Typography color={theme.palette.text.secondary} mt={1}>
            That's a 17% discount compared to monthly billing
          </Typography>
        </Box>

        <Box mb={3}>
          <Typography variant="h6" fontWeight="500" mb={2}>
            Billing Summary
          </Typography>
          <Box display="flex" justifyContent="space-between" mb={2}>
            <Typography>Annual Plan</Typography>
            <Typography>${annualAmount}</Typography>
          </Box>
          <Box display="flex" justifyContent="space-between" mb={2}>
            <Typography>Prorated credits for remaining days</Typography>
            <Typography color="#22B060">-${proRatedAmount}</Typography>
          </Box>
          <Box display="flex" justifyContent="space-between" pt={2} borderTop="1px solid #E8EAF0">
            <Typography fontWeight="500">Amount due today</Typography>
            <Typography fontWeight="500">${annualAmount - proRatedAmount}</Typography>
          </Box>
        </Box>

        <Box mb={3}>
          <Typography variant="h6" fontWeight="500" mb={1}>
            New Billing Date
          </Typography>
          <Box display="flex" alignItems="center" gap={2}>
            <CalenderIcon />
            <Typography>11 Oct, 2025</Typography>
          </Box>
          <Typography color={theme.palette.text.secondary} mt={1}>
            Your next payment will be on this date next year
          </Typography>
        </Box>

        <Box display="flex" gap={2} mt={4}>
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{ flex: 1, borderRadius: "8px" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onConfirm}
            sx={{ flex: 1, borderRadius: "8px" }}
          >
            Confirm and Pay
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default BillingCycleModal; 